//======> Docementation <== ====//
registerBlockType("tornado/home-counter", {
  title: __("Home Counter", "tornado"),
  description: __("HOME COUNTER", "tornado"),
  icon: "feedback",
  category: "tornado",
  keywords: ["tornado", "section"],
  supports: {
    align: ["full", "wide"],
  },
  attributes: {
    BGImage: {
      type: "string",
      default: null,
    },
    featImgAbout: {
      type: "string",
      default: null,
    },
    featImgAbout2: {
      type: "string",
      default: null,
    },
    featImgAbout3: {
      type: "string",
      default: null,
    },
    featImgAbout4: {
      type: "string",
      default: null,
    },
    title: {
      type: "string",
      default: "خبرة راسخة وشغف بالجودة ",
    },
    title2: {
      type: "string",
      default:  "هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل هذا النص أو العديد من النصوص الأخرى إضافة إلى زيادة عدد الحروف التى يولدها التطبيق",
    },
    head: {
      type: "string",
      default: "323",
    },
    head2: {
      type: "string",
      default: "3233",
    },
    head3: {
      type: "string",
      default: "5455",
    },
    head4: {
      type: "string",
      default: "445",
    },
    body: {
      type: "string",
      default: " بنك ومؤسسة مالية بالخليج  ",
    },
    body2: {
      type: "string",
      default: " بنك ومؤسسة مالية بالخليج  ",    },
    body3: {
      type: "string",
      default: " بنك ومؤسسة مالية بالخليج  ",
    },
    body4: {
      type: "string",
      default: " بنك ومؤسسة مالية بالخليج  ",
    },
  },
  //==== Editing Mode ====//
  edit: (props) => {
    //==== Block Data ====//
    const { attributes, setAttributes } = props;
    props.setAttributes( { align: 'full' } );
    function onChangeBackGround(newBG) {
      setAttributes({ BGImage: newBG.sizes.full.url });
    }
    function onChangefeatImg(newIMG) {
      setAttributes({ featImgAbout: newIMG.sizes.full.url });
    }
    function onChangefeatImg2(newIMG2) {
      setAttributes({ featImgAbout2: newIMG2.sizes.full.url });
    }
    function onChangefeatImg3(newIMG3) {
      setAttributes({ featImgAbout3: newIMG3.sizes.full.url });
    }
    function onChangefeatImg4(newIMG4) {
      setAttributes({ featImgAbout4: newIMG4.sizes.full.url });
    }
    const set_title = (title) => {
      setAttributes({ title });
    };
    const set_title2 = (title2) => {
      setAttributes({ title2 });
    };
    const set_head = (head) => {
      setAttributes({ head });
    };
    const set_head2 = (head2) => {
      setAttributes({ head2 });
    };
    const set_head3 = (head3) => {
      setAttributes({ head3 });
    };
    const set_head4 = (head4) => {
      setAttributes({ head4 });
    };

    const set_body1 = (body) => {
      setAttributes({ body });
    };
    const set_body2 = (body2) => {
      setAttributes({ body2 });
    };
    const set_body3 = (body3) => {
      setAttributes({ body3 });
    };
    const set_body4 = (body4) => {
      setAttributes({ body4 });
    };
    return (
      <Panel>
        <InspectorControls style={{ marginBottom: "40px" }}>
          <PanelBody>
            {/* <p>Select The Image For Background !</p>
            <MediaUpload
              onSelect={onChangeBackGround}
              value={attributes.BGImage}
              type="image"
              render={({ open }) => (
                <IconButton icon="upload" onClick={open}>
                  Upload Image! 
                </IconButton>
              )}
            /> */}

            <p>Select The Image for first feature !</p>
            <MediaUpload
              onSelect={onChangefeatImg}
              value={attributes.featImgAbout}
              type="image"
              render={({ open }) => (
                <IconButton icon="upload" onClick={open}>
                  Upload Image! 
                </IconButton>
              )}
            />
            <p>Select The Image for secound feature !</p>
            <MediaUpload
              onSelect={onChangefeatImg2}
              value={attributes.featImgAbout2}
              type="image"
              render={({ open }) => (
                <IconButton icon="upload" onClick={open}>
                  Upload Image! 
                </IconButton>
              )}
            />
            <p>Select The Image for third feature !</p>
            <MediaUpload
              onSelect={onChangefeatImg3}
              value={attributes.featImgAbout3}
              type="image"
              render={({ open }) => (
                <IconButton icon="upload" onClick={open}>
                  Upload Image! 
                </IconButton>
              )}
            />
            <p>Select The Image for FORTH feature !</p>
            <MediaUpload
              onSelect={onChangefeatImg4}
              value={attributes.featImgAbout4}
              type="image"
              render={({ open }) => (
                <IconButton icon="upload" onClick={open}>
                  Upload Image! 
                </IconButton>
              )}
            />
          </PanelBody>
        </InspectorControls>

        <div class="section-small primary-bg hero-section">
          <div class="container">
            <div class="tx-align-center">
              <RichText
                tagName="h2"
                className="mb10"
                onChange={set_title}
                value={attributes.title}
              />

              <RichText
                tagName="p"
                onChange={set_title2}
                value={attributes.title2}
              />
            </div>
            <div class="row gpy-fix">
              <div class="icon-block statistics-block col-12 col-m-6 col-l-3 mb30">
                <div class="content-box flex-box align-center-y">
                  <i class="icon">
                    <img src={attributes.featImgAbout} alt="" />
                  </i>
                  <div class="info col-auto">
                    <RichText
                      tagName="h3"
                      data-counter="365"
                      onChange={set_head}
                      value={attributes.head}
                    />

                    <RichText
                      tagName="p"
                      onChange={set_body1}
                      value={attributes.body}
                    />
                  </div>
                </div>
              </div>
              <div class="icon-block statistics-block col-12 col-m-6 col-l-3 mb30">
                <div class="content-box flex-box align-center-y">
                  <i class="icon">
                    <img src={attributes.featImgAbout2} alt="" />
                  </i> 
                  <div class="info col-auto">
                    <RichText
                      tagName="h3"
                      data-counter="365"
                      onChange={set_head2}
                      value={attributes.head2}
                    />
                    <RichText
                      tagName="p"
                      onChange={set_body2}
                      value={attributes.body2}
                    /> 
                  </div>
                </div>
              </div>
              <div class="icon-block statistics-block col-12 col-m-6 col-l-3 mb30">
                <div class="content-box flex-box align-center-y">
                  <i class="icon">
                    <img src={attributes.featImgAbout3} alt="" />
                  </i>
                  <div class="info col-auto">
                    <RichText
                      tagName="h3"
                      data-counter="365"
                      onChange={set_head3}
                      value={attributes.head3}
                    />
                    <RichText
                      tagName="p"
                      onChange={set_body3}
                      value={attributes.body3}
                    />
                  </div>
                </div>
              </div>
              <div class="icon-block statistics-block col-12 col-m-6 col-l-3 mb30">
                <div class="content-box flex-box align-center-y">
                  <i class="icon">
                    <img src={attributes.featImgAbout4} alt="" />
                  </i>
                  <div class="info">
                    <RichText
                      tagName="h3"
                      data-counter="365"
                      onChange={set_head4}
                      value={attributes.head4}
                    />
                    <RichText
                      tagName="p"
                      onChange={set_body4}
                      value={attributes.body4}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Panel>
    );
  },
  //==== Puplish Mode ====//
  save: (props) => {
    const { attributes } = props;
    return (
      <div class="section-small primary-bg hero-section">
        <div class="container">
          <div class="tx-align-center">
          <RichText.Content tagName="h2" className="mb10" value={attributes.title} />
             <RichText.Content tagName="p" value={attributes.title2} />
          </div>
          <div class="row gpy-fix">
            <div class="icon-block statistics-block col-12 col-m-6 col-l-3 mb30">
              <div class="content-box flex-box align-center-y">
                <i class="icon">
                  <img src={attributes.featImgAbout} alt="" />
                </i>
                <div class="info col-auto">
                  <h3 data-counter={attributes.head}></h3>
                  <RichText.Content tagName="p" value={attributes.body} />
                </div>
              </div>
            </div>
            <div class="icon-block statistics-block col-12 col-m-6 col-l-3 mb30">
              <div class="content-box flex-box align-center-y">
                <i class="icon">
                  <img src={attributes.featImgAbout2} alt="" />
                </i> 
                <div class="info col-auto">
                  <h3 data-counter={attributes.head2}> </h3>
                  <RichText.Content tagName="p" value={attributes.body2} />
                </div>
              </div>
            </div>
            <div class="icon-block statistics-block col-12 col-m-6 col-l-3 mb30">
              <div class="content-box flex-box align-center-y">
                <i class="icon">
                  <img src={attributes.featImgAbout3} alt="" />
                </i> 
                <div class="info col-auto">
                <h3 data-counter={attributes.head3}> </h3>
                <RichText.Content tagName="p" value={attributes.body3} />
                </div>
              </div>
            </div>
            <div class="icon-block statistics-block col-12 col-m-6 col-l-3 mb30">
              <div class="content-box flex-box align-center-y">
                <i class="icon">
                  <img src={attributes.featImgAbout4} alt="" />
                </i> 
                <div class="info">
                <h3 data-counter={attributes.head4}> </h3>
                <RichText.Content tagName="p" value={attributes.body4} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  },
});
